//DefaultFileUpload
export const DEFAULT_FILE_UPLOAD = [
  {
    text: "We use the create method to turn a",
    code: "<input type='file'>",
  },
  {
    text: " into a FilePond drop area.",
    code: "[https://pqina.nl/filepond/]",
  },
];

//Image Previews
export const IMAGE_PREVIEW = [
    {
      text: "We use the create method to turn a",
      code: "<input type='file'>",
    },
    {
      text: " into a FilePond drop area.",
      code: "[https://pqina.nl/filepond/]",
    },
  ];

  //File Uploads
  export const FILE_UPLOAD = [
    {
      text: "Use the ",
      code: ".dropzone ",
    },
    {
      text: "class through create upload files.",
      code: "[https://www.dropzone.dev/].",
    },
  ];